<template>
	<div>
		<compWrapper :title="$t('fbb.alloment.plan_send_detail', { defaultValue: '计划发运明细' })" theme="info">
			<compProduct
				v-if="id"
				class="margin-layout"
				:initFormData="{'search[EQ_transferOutboundPlanId]':id}"
			></compProduct>
		</compWrapper>
		<compWrapper :title="$t('fbb.alloment.box_detail', { defaultValue: '装箱明细' })" theme="success">
			<vButtonGroup class="margin-layout">
				<vButton theme="primary" @click="onceSubmit">{{$t('fbb.inbound.click_packing', { defaultValue: '一键装箱' })}}</vButton>
				<vButton theme="info" @click="handleModal('upload')">{{$t('fbb.alloment.import_box', { defaultValue: '导入装箱' })}}</vButton>
				<!-- <vButton theme="success" @click="finishBoxing">完成装箱</vButton> -->
				<vButton
					theme="warning"
					@click="createBoxingLabel"
					v-if="labelCreateStatus!=10"
				>{{labelCreateStatus==20?$t('fbb.alloment.remake_box_label', { defaultValue:'重新生成箱标' }):$t('fbb.inbound.rawcrates_standard', { defaultValue: '生成箱标' })}}</vButton>
				<vButton theme="info" ghost @click="handleDownload" v-if="labelCreateStatus==20">{{$t('fbb.inbound.download_boxlabel', { defaultValue: '下载箱标' })}}</vButton>
			</vButtonGroup>
			<compFormEdit ref="form" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
			<vButtonGroup class="margin-layout">
				<vButton theme="primary" @click="submitOne">{{$t('fbb.alloment.add_by_one', { defaultValue: '逐个添加' })}}</vButton>
				<vButton theme="warning" @click="delSubmit">{{$t('fbb.alloment.delete_data', { defaultValue: '删除数据' })}}</vButton>
				<vButton theme="error" @click="clearSubmit">{{$t('fbb.alloment.clear_data', { defaultValue: '清空数据' })}}</vButton>
			</vButtonGroup>
			<compEncaselist
				class="margin-layout"
				:startUp="startUp"
				@on-check-change="setCheckData"
				:initFormData="{'search[EQ_transferOutboundPlanId]':id}"
			></compEncaselist>
			<vButton class="margin-right-15" @click="cancel" slot="footer">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
		</compWrapper>
		<vModal
			v-model="modalProps.show"
			:title="modalProps.title"
			:width="modalProps.width||1000"
			:showFooter="false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</vModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import {
	HttpDownloadBoxingLabel,
	HttpDownloadBoxingTemplate,
	HttpCreateBoxingLabel,
	// HttpFinishBoxing,
	HttpImportBoxing,
	HttpOnceBoxing,
	HttpAddBoxing,
	HttpDelBoxing,
	HttpClearBoxing
} from '@/service/allotment';
import { mapGetters } from 'vuex';
import compEncaselist from './encaselist'
import compProduct from './product'
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
		compEncaselist,
		compProduct
	},
	data() {
		return {
			loading: false,
			startUp: 1,
			type: this.$route.params.type,
			id: this.$route.query.id,
			sonId: this.$route.query.sonId,
			isManage:this.$route.query.type,
			// transferOutboundPlanNo:this.$route.query.transferOutboundPlanNo,
			labelCreateStatus: this.$route.query.labelCreateStatus,
			formData: {
				erpSku:""
			},
			modalProps: {
				show: false,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "",
				width: 1000,
				// props: {},
				// on: {},
			}
		};
	},
	computed: {
		getBase() {
			return [
				{
					label: "ERP SKU",
					key: "erpSku",
					tag: "vInput",
					props: {
						readonly: true,
						suffix: "search",
					},
					on: {
						"on-icon-click": () => this.handleModal('erpSku')
					},
				}, {
					label: this.$t('fbb.alloment.box_number', { defaultValue: "装箱数量" }),
					key: "packedQty",
					tag: 'vInputNumber'
				}, {
					label: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
					key: "boxBarcode",
					required: false,
				}, {
					label: this.$t('fbb.alloment.tray_bar_code', { defaultValue: "托盘码" }),
					key: "trayBarcode",
					required: false,
				}, {
					label: this.$t('fbb.alloment.outer_box_weight', { defaultValue: '外箱毛重' }) + "（g）",
					key: "packedWeigth",
					tag: "vInputNumber",
				}, {
					label: this.$t('fbb.alloment.out_box_length', { defaultValue: '外箱长' }) + "（cm）",
					key: "packedLength",
					tag: "vInputNumber",
				}, {
					label: this.$t('fbb.alloment.out_box_width', { defaultValue: '外箱宽' }) + "（cm）",
					key: "packedWidth",
					tag: "vInputNumber",
				}, {
					label: this.$t('fbb.alloment.out_box_height', { defaultValue: '外箱高' }) + "（cm）",
					key: "packedHeight",
					tag: "vInputNumber",
				},
			];
		}
	},
	methods: {

		cancel() {
			if(this.isManage){
	this.$router.push({
				name: 'allotUpdateManage',
				params: { type: "query" },
				query: {
					id: this.sonId
				}
			});
			}else{
				this.$router.push({
				name: 'allotUpdateBill',
				params: { type: "query" },
				query: {
					id: this.id
				}
			});
			}
		
		},
		setCheckData(rows, ids) {
			this.idstr = ids.join(',');
		},
		handleModal(type) {
			if (type === 'upload') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
					component: "compUpload",
					width: 520,
					props: {
						ajaxRequest: HttpImportBoxing,
						name: "multipartFile",
						data: {
							id: this.id
						},
						download: () => {
							this.handleWebfs("/static/template/Transfer_Outbound_Plan_Boxes.xlsx", {}, {
								executor: 'download',
								type: 'url'
							});
							// this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlanBoxItem/transferOutboundPlanBoxItemTemplate", {}, 'download');
						}
					},
					on:{
						'on-success': () => {
							this.modalProps.show = false;
							this.startUp += 1;
						}
					}
				}
				return;
			}
			////获取erp备选
			if (type === 'erpSku') {
				this.modalProps = {
					show: true,
					title: this.$t('fbb.alloment.choose_product', { defaultValue: '选择产品' }),
					component: "compProduct",
					props: {
						initFormData: {
							"search[EQ_transferOutboundPlanId]": this.id
						},
						isSearch: true,
					},
					on: {
						'on-data': (row) => {
							this.formData = Object.assign(this.formData, { erpSku: row.sku, productId: row.productId });
							this.modalProps.show = false;
						}
					}
				}
				return;
			}
		},
		handleDownload() {
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/downloadBoxLabel", {transferOutboundPlanId:this.id}, 'download');
		},
		//生成箱标
		async createBoxingLabel() {
			this.loading = true;
			HttpCreateBoxingLabel({
				transferOutboundPlanNo: this.$route.query.transferOutboundPlanNo,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//完成装箱
		// async finishBoxing() {
		// 	this.loading = true;
		// 	HttpFinishBoxing({
		// 		transferId: this.id,
		// 	}).then(res => {
		// 		this.cancel();
		// 		// this.loading = false;
		// 	}).catch(err => {
		// 		this.loading = false;
		// 		this.$VMessage.error(err.message);
		// 	})
		// },
		async onceSubmit() {
			this.loading = true;
			HttpOnceBoxing({
				id: this.id,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},

		//清空数据
		async clearSubmit() {
			this.loading = true;
			HttpClearBoxing({
				id: this.id,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//删除数据
		async delSubmit() {
			if (!this.idstr) return
			this.loading = true;
			HttpDelBoxing({
				ids: this.idstr,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//逐个添加
		async submitOne() {
			const data = await this.$refs['form'].validate();
			if (!data) return;
			this.loading = true;
			HttpAddBoxing({
				...this.formData,
				transferOutboundPlanId: this.id,
			}).then(res => {
				this.startUp += 1;
				this.formData = {};
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
